import {Component, OnInit} from '@angular/core';
import {AuthService, ChangeRequestVO, requiredFieldValidator, whitelistCharacterValidator} from 'common-domain';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {ChangeRequestService, DomainService} from 'common-domain';
import {PATH_CONSTANTS} from '../../../app-routing.module';
import {USER_PATH_CONSTANTS} from '../../user-routing.module';

@Component({
  selector: 'authorize-request',
  templateUrl: './authorize-request.component.html',
  styleUrls: ['./authorize-request.component.scss']
})
export class AuthorizeRequestComponent implements OnInit {

  requestID: string;

  changeRequestVO: ChangeRequestVO = {};
  changeRequestAcceptRejectForm: FormGroup;
  rejectReasonComment = "";

  constructor(private route: ActivatedRoute, private authService: AuthService, private router: Router, private formBuilder: FormBuilder, private titleService: Title, private domainService: DomainService, private changeRequestService: ChangeRequestService) {
  }

  ngOnInit() {
    this.titleService.setTitle('Authorize Change Request');
    this.getInputData();
    this.createForm();
  }

  onSubmit() {
    const formValue = this.changeRequestAcceptRejectForm.value;
    this.changeRequestService.contactConfirmationResponse(this.requestID, formValue.changeRequestAction, formValue.comment, this.authService.currentUserID()).subscribe(data => {
    }, error => console.log(error), () => {
      this.router.navigate(['/user/home']);
    });
  }

  getInputData() {
    this.route.params.subscribe(params => {
      this.requestID = params['requestNumber'];
      if (this.requestID) {
        this.changeRequestService.getChangeRequestDetails(this.requestID).subscribe(data => {
          this.changeRequestVO = data;
        }, error => {
          this.router.navigateByUrl('/user/home');
        }, () => {
        });
      } else {
        this.router.navigateByUrl('/user/home');
      }
    });
  }


  goBack() {
    this.router.navigateByUrl(PATH_CONSTANTS.USER + PATH_CONSTANTS.SLASH + USER_PATH_CONSTANTS.REQUEST_DETAILS + this.requestID);
  }

  get comment(): FormControl { return this.changeRequestAcceptRejectForm.get('comment') as FormControl; }

  private createForm() {
    this.changeRequestAcceptRejectForm = this.formBuilder.group({
      changeRequestAction: new FormControl('', [requiredFieldValidator]),
      comment: new FormControl('', whitelistCharacterValidator)
    });
  }

  isFormInValid() {
    const valid = this.changeRequestAcceptRejectForm.valid;
    if (!valid) {
      return true;
    }
    const reason = this.changeRequestAcceptRejectForm.value.comment;
    const action = this.changeRequestAcceptRejectForm.value.changeRequestAction;

    if (action === 'APPROVE') {
      return false;
    } else if (action === 'REJECT') {
      return !reason;
    } else {
      return true;
    }
  }

  resetRejectComments(evt) {
    const target = evt.target;
    if (target.id === 'approve' && target.checked) {
      this.rejectReasonComment = "";
      this.changeRequestAcceptRejectForm.value.comment ="";
    }

  }
}
